/* eslint-disable react/prop-types */
import React from 'react';
import AuthenticatedMenuBar from 'client/containers/Genesis/Menu/AuthenticatedMenuBar';
import menuPropsUS from 'client/containers/Genesis/Menu/menuPropsUS';
import menuPropsCN from 'client/containers/Genesis/Menu/menuPropsCN';
import url from 'client/utils/url';
import Box from '@ff/ui/Box';

export default function HeaderLayout({ children }) {
  const region = url.getRegion();
  const isCNRegion = region === 'CN';
  const menuProps = isCNRegion ? menuPropsCN : menuPropsUS;
  const MENU_PROPS = window?.MENU_PROPS || menuProps;

  return (
    <Box>
      <AuthenticatedMenuBar {...MENU_PROPS} />
      <main>{children}</main>
    </Box>
  );
}
